<template>
  <div>
    <!-- Game Desktop Header -->
    <nav
      id="desktop-header"
      class="d-flex justify-content-start white-text hidden-mobile vh-10"
    >
      <div
        id="game-menu"
        class="d-flex align-items-center justify-content-start white-text"
      >
        <div
          class="flex-fill d-flex align-items-center justify-content-center text-center"
        >
          <div
            v-if="!teamDataLoading && !teamsLoading"
            id="game-menu"
            class="row d-flex align-items-center justify-content-start white-text"
            style="width: 100% !important"
          >
            <div
              class="flex-fill d-flex align-items-center justify-content-center text-center"
            >
              <div
                v-if="isPreviewGame"
                style="width: 100% !important; height: 100% !important; background-color:yellow"
              >
                <select style="margin: 10px" v-model="previewChallengeIndex">
                  <option :value="null" disabled>Challenge</option>
                  <option
                    v-for="(challengeDetails, index) in previewChallenges"
                    :key="index"
                    :value="challengeDetails.challengeIndex"
                    >{{ challengeDetails.title }}</option
                  >
                </select>
                <select
                  v-model="previewQuestionIndex"
                  style="padding-right: 50px"
                >
                  <option :value="null" disabled>Question</option>
                  <option
                    v-for="(questionDetails, index) in previewQuestions"
                    :key="index"
                    :value="questionDetails.index"
                    >{{ questionDetails.title }}</option
                  >
                </select>

                <button
                  style="color: white; cursor: pointer; background-color: black; width:80px; text-align: center;margin: 10px;font-family: termina, sans-serif;border-radius:10px;border: 1px solid black !important; font-size: 16px !important; font-weight: 500;"
                  @click="doPreviewNavigation"
                >
                  Go
                  <div
                    v-if="awaitingServerResponse"
                    class="button-loading-spinner"
                  ></div>
                </button>
              </div>
              <a v-else style="cursor: pointer" @click="goHome"
                ><img
                  :src="resolveGameAssetURL(gameID, gameLogo)"
                  alt="Home Logo"
                  class="home-logo"
                />
              </a>
            </div>
          </div>
        </div>
        <div
          class="flex-fill d-flex align-items-center justify-content-center menu-icon text-center"
        >
          <a style="cursor: pointer" @click="goHome"
            ><img
              v-if="!useBlackIcons"
              src="@/assets/images/icons/be-icon-home.svg"
              alt="home"
            /><img
              v-else
              src="@/assets/images/icons/be-icon-home.svg"
              alt="home"
            /><span class="title">home</span></a
          >
        </div>
        <div
          class="flex-fill d-flex align-items-center justify-content-center menu-icon text-center"
        >
          <router-link
            :to="{
              name: 'game-scoreboard',
              params: { code: code, team_id: team_id }
            }"
            ><img
              src="@/assets/images/icons/be-icon-leaderboard.svg"
              class="leaderboard-icon"
              alt="leaderboard"
            /><span class="title">Leaderboard</span></router-link
          >
        </div>
        <div
          class="flex-fill d-flex align-items-center justify-content-center menu-icon text-center"
        >
          <router-link
            :to="{
              name: 'game-rewards',
              params: { code: code, team_id: team_id }
            }"
            ><img
              src="@/assets/images/icons/be-icon-reward.svg"
              alt="inventory"
            /><span class="title">Inventory</span></router-link
          >
        </div>
        <div
          class="flex-fill d-flex align-items-center justify-content-center menu-icon text-center"
        >
          <router-link
            :to="{
              name: 'confirm-logout'
            }"
            ><img
              src="@/assets/images/icons/be-icon-exit.svg"
              alt="logout"
            /><span class="title">Logout</span></router-link
          >
        </div>
      </div>

      <!-- sidebar - progress bar -->
      <div
        id="team-score"
        class="d-flex align-items-center justify-content-start white-text vh-10 sidebar-progress"
      >
        <div
          class="vh-10 d-flex align-items-center col-6 no-gutter-left no-gutter-right pad-left-30 pad-right-30"
        >
          <div class="pad-left-30 pad-right-30 w-100">
            <p class="bold mt-0 pb-0 mb-0 w-100">{{ teamName }}</p>
          </div>
        </div>

        <div
          class="vh-10 d-flex align-items-center col-6 no-gutter-left no-gutter-right"
        >
          <p class="mt-0 pb-0 mb-0 alignleft pad-left-30 w-50">Score</p>
          <h3 class="mt-0 pb-0 mb-0 text-right alignright pad-right-30 w-50">
            {{ points }}
          </h3>
          <div class="clear-both"></div>
        </div>
      </div>
    </nav>

    <!-- Game Mobile Modal -->

    <div id="open-mobile-menu" class="modal-window visible-mobile">
      <!-- Modal Nav -->
      <nav
        id="mobile-header"
        class="p-0 cont-fullwidth back-colour white-text visible-mobile"
      >
        <div class="row m-0 d-flex align-content-center vh-7-5">
          <div
            class="col-12 d-flex align-items-center justify-content-center no-gutter-left no-gutter-right"
          >
            <div
              id="game-menu-mobile"
              class="row d-flex align-items-center justify-content-start w-100"
            >
              <div class="flex-fill d-flex align-items-center pad-left-30 w-50">
                <a style="cursor: pointer" @click="goHome">
                  <!-- Game Logo -->
                  <img
                    v-if="!teamDataLoading && !teamsLoading"
                    class="home-logo-mobile"
                    :src="resolveGameAssetURL(gameID, gameLogo)"
                    alt="logo"
                  />
                </a>
              </div>
              <div
                class="d-flex align-items-center justify-content-center menu-icon text-center"
              >
                <a href="#" class="modal-close">
                  <img
                    src="@/assets/images/icons/be-icon-close.svg"
                    alt="logout"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </nav>

      <!-- Modal Leaderboard -->

      <section class="cont-fullwidth white-text p-0">
        <div class="row innerpadding-30 m-0">
          <div class="flex-fill d-flex align-items-center w-100">
            <img
              src="@/assets/images/icons/be-icon-leaderboard.svg"
              alt="leaderboard"
              class="leaderboard-icon"
            />
            <h2 class=" mt-0 pb-0 mb-0">Leaderboard</h2>

            <router-link
              :to="{
                name: 'game-scoreboard',
                params: { code: code, team_id: team_id }
              }"
            >
              <img
                src="@/assets/images/icons/be-icon-viewall.svg"
                class="viewall-icon"
                alt="view all"
              />
            </router-link>
          </div>
        </div>
        <div class="row m-0 ">
          <!-- Modal Leaderboard item -->
          <div
            v-for="(item, index) in topThreeTeams"
            :key="index"
            class="col-12 leaderboard-item-modal no-gutter-left no-gutter-right d-flex"
          >
            <div class="flex-fill count-width">
              <h2 class=" pb-0 mb-0 mt-0">1</h2>
            </div>
            <div class="flex-fill team-width">
              <h2 class="termina-reg pb-0 mb-0 mt-0">{{ item.teamName }}</h2>
            </div>
            <div class="flex-fill score-width">
              <h2 class="termina-reg pb-0 mb-0 mt-0 text-right">
                {{ item.points }}
              </h2>
            </div>
          </div>
        </div>
      </section>

      <!-- Modal Clues & Rewards -->

      <section class="cont-fullwidth white-text p-0">
        <div class="row m-0 innerpadding-30">
          <div class="flex-fill d-flex align-items-center w-50">
            <img
              src="@/assets/images/icons/be-icon-reward.svg"
              class="reward-icon"
              alt="leaderboard"
            />
            <h2 class="mt-0 pb-0 mb-0">Inventory</h2>
            <router-link
              :to="{
                name: 'game-rewards',
                params: { code: code, team_id: team_id }
              }"
              class="flex-fill d-flex align-items-center"
            >
              <img
                src="@/assets/images/icons/be-icon-viewall.svg"
                class="viewall-icon"
                alt="view all"
              />
            </router-link>
          </div>

          <div class="row m-0 pad-top-30 white-text" v-if="inventory">
            <div
              v-for="(inventoryItem, index) in inventory.slice(-3)"
              :key="index"
              class="col-4 reward text-center"
            >
              <div
                class="reward-item text-center d-flex align-items-center justify-content-center"
              >
                <img
                  class="img-fluid"
                  :src="resolveGameAssetURL(gameID, inventoryItem.image)"
                  alt="reward"
                />
              </div>
              <span class="small white-text">{{ inventoryItem.title }}</span>
            </div>
          </div>
        </div>
      </section>

      <!-- Help + Logout -->
      <section class="cont-fullwidth white-text logout">
        <div class="row innerpadding-30 m-0">
          <div
            class="flex-fill d-flex align-items-center w-100"
            @click="logout"
          >
            <img
              src="@/assets/images/icons/be-icon-exit.svg"
              class="leaderboard-icon"
              alt="leaderboard"
            />
            <h2 class=" mt-0 pb-0 mb-0">Log Out</h2>
          </div>
        </div>
      </section>
    </div>
    <!-- Modal End -->

    <!-- Game Mobile Header -->
    <nav
      id="mobile-header"
      class="p-0 cont-fullwidth back-colour white-text visible-mobile"
    >
      <div class="row d-flex align-content-center vh-7-5 m-0">
        <div
          class="col-12 d-flex align-items-center justify-content-center no-gutter-left no-gutter-right"
        >
          <div
            id="game-menu-mobile"
            class="row d-flex align-items-center justify-content-start w-100"
          >
            <div class="flex-fill d-flex align-items-center pad-left-30 w-50">
              <a style="cursor: pointer" @click="goHome">
                <!-- Game Logo -->
                <img
                  :src="resolveGameAssetURL(gameID, gameLogo)"
                  alt="Game Logo"
                  class="home-logo-mobile"
                />
              </a>
            </div>
            <div
              class="flex-fill d-flex align-items-center justify-content-center score-icon text-center w-15"
            >
              <h2 class="termina-reg mt-0 pb-0 mb-0">{{ points }}</h2>
            </div>
            <div
              class="d-flex align-items-center justify-content-center menu-icon text-center"
            >
              <a href="#open-mobile-menu">
                <img
                  src="@/assets/images/icons/be-icon-menu-updated.svg"
                  alt="logout"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import { gameAssetsMixin } from '../mixins/gameAssetsMixin'
import { challengeNavigationMixin } from '../mixins/challengeNavigationMixin'
import { mapState, mapActions } from 'vuex'
import _debounce from 'lodash/debounce'

export default {
  mixins: [gameAssetsMixin, challengeNavigationMixin],

  props: {
    code: { type: String, required: true },
    team_id: { type: String, required: true }
  },
  created() {
    if (
      this.game.teams === undefined ||
      this.game.teams[0]?.gameCode != this.code
    ) {
      this.fetchTeams({ code: this.code })
    }
    if (this.gameData === undefined || this.game.teamData?.id != this.team_id) {
      this.fetchTeamData({ code: this.code, teamId: this.team_id })
    }

    document.body.classList.remove('purple-bg')

    this.previewChallengeIndex = this.currentChallengeIndex
    this.previewQuestionIndex = this.currentChallengeData?.currentQuestionIndex
  },
  mounted() {
    if (!this.teamDataLoading) {
      console.log(
        `Header: Mounted: gameData loaded. Loading stylesheet for gameboard: ${this.gameboard}`
      )
      this.addGameStylesheet()
    }
  },
  watch: {
    teamDataLoading: function(newValue, oldValue) {
      if (oldValue === false && newValue === true) {
        console.log(
          `Header: gameData loaded. Loading stylesheet for gameboard: ${this.gameboard}`
        )
        this.addGameStylesheet()
      }
    },
    allTeams: function(newAllTeams) {
      _debounce(
        () => {
          console.log('DEBOUNCED')
          this.generateNewActivityStatements(newAllTeams)
        },
        10000,
        {
          leading: true,
          trailing: false
        }
      )()
    },
    questionIndex(newValue, oldValue) {
      console.log(`questionIndex changing from ${oldValue} to ${newValue}`)

      this.previewQuestionIndex = newValue
    }
  },
  computed: {
    ...mapState({
      game: state => state.game
    }),
    isSinglePlayer() {
      return this.game.teamData?.teamMembers.length <= 1
    },
    topThreeTeams() {
      let teams = this.game.teams || []

      return teams.slice(0, 3)
    },
    allTeams() {
      return this.game.teams?.slice()
    },
    inventory() {
      return this.game.teamData?.inventory
    },
    teamName() {
      return this.game.teamData?.teamName
    },
    points() {
      return this.game.teamData?.points
    },
    gameData() {
      return this.game.teamData?.gameData
    },
    gameID() {
      return this.game.teamData?.game
    },
    gameLogo() {
      return this.gameData?.logo
    },
    gameboard() {
      return this.gameData?.gameboard
    },
    currentChallengeIndex() {
      return this.game.teamData?.gameData?.currentChallengeIndex
    },
    currentChallengeData() {
      if (
        this.currentChallengeIndex === undefined ||
        this.currentChallengeIndex === null
      ) {
        return undefined
      }

      return this.game.teamData?.gameData?.challenges[
        this.currentChallengeIndex
      ]
    },
    questionIndex() {
      return this.currentChallengeData?.currentQuestionIndex
    },
    isPreviewGame() {
      return this.game.teamData?.isPreview ?? false
    },
    previewChallenges() {
      if (!this.game.teamData?.isPreview) {
        return null
      }

      const challenges = this.game.teamData?.gameData?.challenges.map(
        (challenge, index) => {
          return { title: challenge.title, challengeIndex: index }
        }
      )

      return [
        {
          title: 'Introduction',
          challengeIndex: this.$constants.INTRO_CHALLENGE_INDEX
        },
        {
          title: 'Challenge List',
          challengeIndex: this.$constants.GAMEBOARD_CHALLENGE_INDEX
        },
        ...challenges
      ]
    },
    previewQuestions() {
      if (!this.game.teamData?.isPreview) {
        return null
      }
      if (this.previewChallengeIndex < 0) {
        return []
      }

      const previewChallenge = this.game.teamData?.gameData?.challenges[
        this.previewChallengeIndex
      ]
      const questions = previewChallenge?.questions.map((question, index) => {
        return {
          title: question.title,
          index
        }
      })

      return questions ?? []
    },
    teamsLoading() {
      return this.game.teams === undefined
    },
    teamDataLoading() {
      return this.game.teamData?.gameData === undefined
    },
    useBlackIcons() {
      return this.gameboard === 'the-perfect-pitch'
    }
  },
  data: () => ({
    previousAllTeams: null,
    previewChallengeIndex: null,
    previewQuestionIndex: null
  }),
  methods: {
    ...mapActions('game', ['fetchTeamData', 'fetchTeams']),
    ...mapActions('activity', ['addActivity']),
    addGameStylesheet() {
      console.log(`addGameStylesheet: Gameboard: ${this.gameboard}`)

      let stylesheetURL

      if (this.gameboard === 'great-games-challenge') {
        stylesheetURL = 'css/great-games-challenge.css'

        this.setGameboardBodyClass('great-games-challenge')
      } else if (this.gameboard === 'the-perfect-pitch') {
        stylesheetURL = 'css/the-perfect-pitch.css'

        this.setGameboardBodyClass('the-perfect-pitch')
      } else if (this.gameboard === 'save-pop-culture') {
        stylesheetURL = 'css/save-pop-culture.css'

        this.setGameboardBodyClass('save-pop-culture')
      } else if (this.gameboard === 'the-big-quiz') {
        stylesheetURL = 'css/the-big-quiz.css'

        this.setGameboardBodyClass('the-big-quiz')
      } else {
        stylesheetURL = 'css/big-escape.css'

        this.setGameboardBodyClass('big-escape')
      }

      var element = document.createElement('link')
      element.setAttribute('rel', 'stylesheet')
      element.setAttribute('type', 'text/css')
      element.setAttribute('href', this.resolveGeneralAssetURL(stylesheetURL))
      document.getElementsByTagName('head')[0].appendChild(element)
    },
    setGameboardBodyClass(currentGameboardName = null) {
      let gameboards = [
        'great-games-challenge',
        'the-perfect-pitch',
        'big-escape',
        'save-pop-culture',
        'the-big-quiz'
      ]

      gameboards.forEach(gameboard => {
        if (gameboard === currentGameboardName) {
          console.log('adding gameboard class: ', gameboard)
          document.body.classList.add(gameboard)
        } else {
          console.log('removing bameboard class: ', gameboard)
          document.body.classList.remove(gameboard)
        }
      })

      document.body.classList.remove('onboarding')
    },
    doPreviewNavigation() {
      if (!this.game.teamData?.isPreview) {
        return
      }

      console.log(
        `😙😙😙 doPreviewNavigation: Challenge: ${this.previewChallengeIndex}, Question: ${this.previewQuestionIndex}`
      )

      if (this.previewChallengeIndex !== this.currentChallengeIndex) {
        this.awaitingServerResponse = true
        this.$store
          .dispatch('game/updateCurrentChallenge', {
            code: this.code,
            teamId: this.team_id,
            challengeIndex: this.previewChallengeIndex
          })
          .catch(error => {
            this.awaitingServerResponse = false

            //TODO: Handle error
            console.log('Error while updating preview challenge index: ', error)
          })
      }

      if (
        this.previewChallengeIndex >= 0 &&
        this.previewQuestionIndex !== null
      ) {
        this.awaitingServerResponse = true
        this.$store
          .dispatch('game/updateCurrentQuestion', {
            code: this.code,
            teamId: this.team_id,
            challengeIndex: this.previewChallengeIndex,
            questionIndex: this.previewQuestionIndex
          })
          .then(() => {
            location.reload()
          })
          .catch(error => {
            console.log('Error while updating preview question index: ', error)
            this.awaitingServerResponse = false
          })
      }
    },
    goToChallenge(index) {
      if (this.isSinglePlayer) {
        this.setCurrentChallengeIndex(this.code, this.team_id, index)
      } else {
        this.setProposedChallengeIndex(this.code, this.team_id, index)
      }
    },
    goHome() {
      if (
        this.$route.name === 'challenge-play' &&
        (this.gameData?.currentChallengeIndex ===
          this.$constants.GAMEBOARD_CHALLENGE_INDEX ||
          this.gameData?.currentChallengeIndex ===
            this.$constants.INTRO_CHALLENGE_INDEX)
      ) {
        // You're already at home (Granny)
        return
      }

      if (
        this.$route.name === 'challenge-play' &&
        !this.currentChallengeData?.hidden
      ) {
        this.goToChallenge(this.$constants.GAMEBOARD_CHALLENGE_INDEX)
      } else {
        this.$router.push({
          name: 'challenge-play',
          params: {
            code: this.code,
            team_id: this.team_id,
            challengeIndex: this.gameData.currentChallengeIndex
          }
        })
        // }
      }
    },
    logout() {
      this.$router.push({
        name: 'confirm-logout'
      })
    },
    generateActivityStatementForFirstPlace(previousAllTeams, newAllTeams) {
      if (
        previousAllTeams[0] !== undefined &&
        newAllTeams[0] !== undefined &&
        newAllTeams[0]?.teamId != previousAllTeams[0]?.teamId
      ) {
        if (newAllTeams[0]?.teamId === this.team_id) {
          return `Great work. Your team just moved into first place!`
        } else {
          return `${newAllTeams[0]?.teamName} have taken the lead!`
        }
      }
    },
    generateActivityStatementForTeamPosition(
      previousTeamIndex,
      currentTeamIndex
    ) {
      if (previousTeamIndex !== currentTeamIndex) {
        console.log(
          `👀 teamIndex has changed from ${previousTeamIndex} to ${currentTeamIndex}`
        )

        if (currentTeamIndex < previousTeamIndex) {
          if (previousTeamIndex - currentTeamIndex > 1) {
            return `Well done. You have just moved up ${previousTeamIndex -
              currentTeamIndex} places on the leaderboard!`
          } else {
            return 'Well done. You have moved up a place on the leaderboard!'
          }
        }
      }
    },
    generateActivityStatementForPoints(
      previousAllTeams,
      newAllTeams,
      previousTeamIndex,
      currentTeamIndex
    ) {
      if (
        newAllTeams[currentTeamIndex].points >
        previousAllTeams[previousTeamIndex].points
      ) {
        if (
          newAllTeams[currentTeamIndex].points >= 100 &&
          previousAllTeams[previousTeamIndex].points < 100
        ) {
          return "You've just reached 100 Points!"
        } else if (
          newAllTeams[currentTeamIndex].points >= 50 &&
          previousAllTeams[previousTeamIndex].points < 50
        ) {
          return "You've just reached 50 Points!"
        }
      }
    },
    generateNewActivityStatements(newAllTeamsParam) {
      console.log('👹👹👹 Called generateNewActivityStatements')

      const newAllTeams = newAllTeamsParam.map(team => {
        return {
          teamId: team.id,
          ...team
        }
      })

      if (this.previousAllTeams === null) {
        this.previousAllTeams = newAllTeams

        return
      }

      const previousAllTeams = this.previousAllTeams
      this.previousAllTeams = newAllTeams
      //---
      // Step 1: Check for first place related activity
      //---
      let activityStatement = this.generateActivityStatementForFirstPlace(
        previousAllTeams,
        newAllTeams
      )
      if (activityStatement !== undefined) {
        this.addActivity(activityStatement)
        return
      }

      let previousTeamIndex = previousAllTeams.findIndex(
        team => team.teamId === this.team_id
      )
      let currentTeamIndex = newAllTeams.findIndex(
        team => team.teamId === this.team_id
      )

      if (previousTeamIndex !== -1 && currentTeamIndex !== -1) {
        // ---
        // Step 2: Check for position number activity
        // ---
        activityStatement = this.generateActivityStatementForTeamPosition(
          previousTeamIndex,
          currentTeamIndex
        )
        if (activityStatement !== undefined) {
          this.addActivity(activityStatement)
          return
        }

        // ---
        // Step 3: Check for points activity
        // ---
        activityStatement = this.generateActivityStatementForPoints(
          previousAllTeams,
          newAllTeams,
          previousTeamIndex,
          currentTeamIndex
        )
        if (activityStatement !== undefined) {
          this.addActivity(activityStatement)
          return
        }
      }
    }
  }
}
</script>

<style></style>
